import axios from 'axios';
import { API_HOST } from '../constants/constants';
import useCurrentUser from '../hooks/useCurrentUser';

export const getOrders = async (userIDOverride) => {
  const { userID, token } = useCurrentUser();
  if (!userID || !token) {
    return null;
  }
  const apiURL = userIDOverride
    ? `${API_HOST}/orders/get_orders?user_id=${userIDOverride}`
    : `${API_HOST}/orders/get_orders`;

  try {
    const { data } = await axios.get(apiURL, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
        'x-dqpn-user-id': userID,
      },
    });

    // console.log('here is the data from getOrders: ', data);
    return data;
  } catch (error) {
    console.error('Error fetching orders:', error);
    return null;
  }

  // Mock data for testing with hardcoded statuses
  const testData = {
    thisWeekOrders: [
      {
        id: 3,
        status: 'Delivered',
        mealGenre: 'asian',
        deliveryDate: 'Dec 31, 2024',
        address: '1234 Elm Street, Springfield, IL 62704',
        orderPlaced: 'March 1, 2024',
        shipped: 'March 15, 2024',
        meals: [
          { name: 'Lemongrass Chicken', quantity: 3, id: '001' },
          { name: 'Beef Pho', quantity: 2, id: '002' },
          { name: 'Tofu Pad Thai', quantity: 5, id: '003' },
          { name: 'Hainanese Chicken', quantity: 4, id: '004' },
        ],
      },
    ],
    nextWeekOrders: [
      {
        id: 4,
        status: 'On the way',
        mealGenre: 'mediterranean',
        deliveryDate: 'Jan 4, 2025',
        address: '5678 Oak Avenue, Metropolis, NY 10001',
        orderPlaced: 'March 5, 2024',
        shipped: 'March 20, 2024',
        meals: [
          { name: 'Lemongrass Chicken', quantity: 4, id: '001' },
          { name: 'Beef Pho', quantity: 1, id: '002' },
          { name: 'Tofu Pad Thai', quantity: 3, id: '003' },
          { name: 'Hainanese Chicken', quantity: 2, id: '004' },
        ],
      },
    ],
    futureOrders: [
      {
        id: 5,
        status: 'Future',
        mealGenre: 'latin',
        deliveryDate: 'Jan 25, 2025',
        address: '9101 Maple Lane, Gotham, NJ 07001',
        orderPlaced: 'March 10, 2024',
        shipped: 'March 25, 2024',
        meals: [
          { name: 'Lemongrass Chicken', quantity: 2, id: '001' },
          { name: 'Beef Pho', quantity: 5, id: '002' },
          { name: 'Tofu Pad Thai', quantity: 1, id: '003' },
          { name: 'Hainanese Chicken', quantity: 4, id: '004' },
        ],
      },
      {
        id: 6,
        status: 'Future', // Hardcoded status
        mealGenre: 'american',
        deliveryDate: 'Jan 12, 2025',
        address: '1234 Elm Street, Springfield, IL 62704',
        orderPlaced: 'December 1, 2024',
        shipped: 'December 20, 2024',
        meals: [
          { name: 'Lemongrass Chicken', quantity: 1, id: '001' },
          { name: 'Beef Pho', quantity: 3, id: '002' },
          { name: 'Tofu Pad Thai', quantity: 4, id: '003' },
          { name: 'Hainanese Chicken', quantity: 5, id: '004' },
        ],
      },
      {
        id: 7,
        status: 'Future', // Hardcoded status
        mealGenre: 'mediterranean',
        deliveryDate: 'Jan 19, 2025',
        address: '5678 Oak Avenue, Metropolis, NY 10001',
        orderPlaced: 'December 5, 2024',
        shipped: 'December 25, 2024',
        meals: [
          { name: 'Lemongrass Chicken', quantity: 5, id: '001' },
          { name: 'Beef Pho', quantity: 2, id: '002' },
          { name: 'Tofu Pad Thai', quantity: 3, id: '003' },
          { name: 'Hainanese Chicken', quantity: 1, id: '004' },
        ],
      },
      {
        id: 8,
        status: 'Future', // Hardcoded status
        mealGenre: 'latin',
        deliveryDate: 'Jan 26, 2025',
        address: '9101 Maple Lane, Gotham, NJ 07001',
        orderPlaced: 'December 10, 2024',
        shipped: 'December 30, 2024',
        meals: [
          { name: 'Lemongrass Chicken', quantity: 4, id: '001' },
          { name: 'Beef Pho', quantity: 1, id: '002' },
          { name: 'Tofu Pad Thai', quantity: 2, id: '003' },
          { name: 'Hainanese Chicken', quantity: 5, id: '004' },
        ],
      },
      {
        id: 9,
        status: 'Future', // Hardcoded status
        mealGenre: 'asian',
        deliveryDate: 'Feb 2, 2025',
        address: '2468 Pine Road, Star City, CA 90210',
        orderPlaced: 'December 15, 2024',
        shipped: 'January 5, 2025',
        meals: [
          { name: 'Lemongrass Chicken', quantity: 3, id: '001' },
          { name: 'Beef Pho', quantity: 4, id: '002' },
          { name: 'Tofu Pad Thai', quantity: 1, id: '003' },
          { name: 'Hainanese Chicken', quantity: 2, id: '004' },
        ],
      },
    ],
    distantFutureOrders: [
      {
        id: 6,
        status: 'Future', // Hardcoded status
        mealGenre: 'american',
        deliveryDate: 'Jan 12, 2025',
        address: '1234 Elm Street, Springfield, IL 62704',
        orderPlaced: 'December 1, 2024',
        shipped: 'December 20, 2024',
        meals: [
          { name: 'Lemongrass Chicken', quantity: 1, id: '001' },
          { name: 'Beef Pho', quantity: 3, id: '002' },
          { name: 'Tofu Pad Thai', quantity: 4, id: '003' },
          { name: 'Hainanese Chicken', quantity: 5, id: '004' },
        ],
      },
      {
        id: 7,
        status: 'Future', // Hardcoded status
        mealGenre: 'mediterranean',
        deliveryDate: 'Jan 19, 2025',
        address: '5678 Oak Avenue, Metropolis, NY 10001',
        orderPlaced: 'December 5, 2024',
        shipped: 'December 25, 2024',
        meals: [
          { name: 'Lemongrass Chicken', quantity: 5, id: '001' },
          { name: 'Beef Pho', quantity: 2, id: '002' },
          { name: 'Tofu Pad Thai', quantity: 3, id: '003' },
          { name: 'Hainanese Chicken', quantity: 1, id: '004' },
        ],
      },
      {
        id: 8,
        status: 'Future', // Hardcoded status
        mealGenre: 'latin',
        deliveryDate: 'Jan 26, 2025',
        address: '9101 Maple Lane, Gotham, NJ 07001',
        orderPlaced: 'December 10, 2024',
        shipped: 'December 30, 2024',
        meals: [
          { name: 'Lemongrass Chicken', quantity: 4, id: '001' },
          { name: 'Beef Pho', quantity: 1, id: '002' },
          { name: 'Tofu Pad Thai', quantity: 2, id: '003' },
          { name: 'Hainanese Chicken', quantity: 5, id: '004' },
        ],
      },
      {
        id: 9,
        status: 'Future', // Hardcoded status
        mealGenre: 'asian',
        deliveryDate: 'Feb 2, 2025',
        address: '2468 Pine Road, Star City, CA 90210',
        orderPlaced: 'December 15, 2024',
        shipped: 'January 5, 2025',
        meals: [
          { name: 'Lemongrass Chicken', quantity: 3, id: '001' },
          { name: 'Beef Pho', quantity: 4, id: '002' },
          { name: 'Tofu Pad Thai', quantity: 1, id: '003' },
          { name: 'Hainanese Chicken', quantity: 2, id: '004' },
        ],
      },
    ],
    historyOrders: [
      {
        id: 0,
        status: 'Delivered', // Hardcoded status
        mealGenre: 'american',
        deliveryDate: 'Mar 15, 2024',
        address: '1357 Birch Street, Central City, CO 80022',
        orderPlaced: 'February 1, 2024',
        shipped: 'February 20, 2024',
        meals: [
          { name: 'Lemongrass Chicken', quantity: 2, id: '001' },
          { name: 'Beef Pho', quantity: 5, id: '002' },
          { name: 'Tofu Pad Thai', quantity: 3, id: '003' },
          { name: 'Hainanese Chicken', quantity: 1, id: '004' },
        ],
      },
      {
        id: 1,
        status: 'Order Placed', // Hardcoded status
        mealGenre: 'latin',
        deliveryDate: 'Mar 22, 2024',
        address: '8642 Cedar Avenue, Coast City, FL 33101',
        orderPlaced: 'February 5, 2024',
        shipped: 'February 25, 2024',
        meals: [
          { name: 'Lemongrass Chicken', quantity: 4, id: '001' },
          { name: 'Beef Pho', quantity: 1, id: '002' },
          { name: 'Tofu Pad Thai', quantity: 5, id: '003' },
          { name: 'Hainanese Chicken', quantity: 2, id: '004' },
        ],
      },
      {
        id: 2,
        status: 'Shipped', // Hardcoded status
        mealGenre: 'mediterranean',
        deliveryDate: 'Mar 29, 2024',
        address: '9753 Willow Drive, Keystone City, KS 66062',
        orderPlaced: 'February 10, 2024',
        shipped: 'March 1, 2024',
        meals: [
          { name: 'Lemongrass Chicken', quantity: 1, id: '001' },
          { name: 'Beef Pho', quantity: 3, id: '002' },
          { name: 'Tofu Pad Thai', quantity: 2, id: '003' },
          { name: 'Hainanese Chicken', quantity: 4, id: '004' },
        ],
      },
    ],
    mealInfo: {
      '001': {
        mealName: 'Lemongrass Chicken',
        description: 'A fragrant and flavorful dish featuring tender chicken marinated in lemongrass and spices.',
        tags: ['gluten free', 'low fodmap'],
        ingredients:
          'Extra Firm Tofu, Rice Noodle (Rice, Water), Napa Cabbage, Green Bell Pepper, Water, Carrot, Crimini Mushrooms, Kikkoman LESS SODIUM GLUTEN-FREE TAMARI Soy Sauce (Water, Soybeans, Salt, Sugar, Alcohol, Vinegar, Lactic Acid), Olive Oil, Green Onion, Liquid Smoke, Rice Vinegar(Diluted with Water to 4.2% Acidity), Smooth Natural Peanut Butter, Sambal Oelek(Chili, Salt, Acetic Acid, Potassium Sorbate And Sodium Bisulfite As Preservative), Garlic, Maple Syrup, Garlic Powder, Cornstarch, Smoked Paprika, Peanuts, Cilantro, Ground Ginger, Ground Black Pepper, Salt',
        instructions:
          'Remove cover. Microwave for 1-3 minutes. Remove lid & stir contents. Microwave for 1-2 minutes more or until 165°F. Plate food, let stand & enjoy!',
      },
      '002': {
        mealName: 'Beef Pho',
        description: 'A hearty Vietnamese soup with rich beef broth, rice noodles, and tender beef slices.',
        tags: ['protein dense', 'low fodmap'],
        ingredients:
          'Extra Firm Tofu, Rice Noodle (Rice, Water), Napa Cabbage, Green Bell Pepper, Water, Carrot, Crimini Mushrooms, Kikkoman LESS SODIUM GLUTEN-FREE TAMARI Soy Sauce (Water, Soybeans, Salt, Sugar, Alcohol, Vinegar, Lactic Acid), Olive Oil, Green Onion, Liquid Smoke, Rice Vinegar(Diluted with Water to 4.2% Acidity), Smooth Natural Peanut Butter, Sambal Oelek(Chili, Salt, Acetic Acid, Potassium Sorbate And Sodium Bisulfite As Preservative), Garlic, Maple Syrup, Garlic Powder, Cornstarch, Smoked Paprika, Peanuts, Cilantro, Ground Ginger, Ground Black Pepper, Salt',
        instructions:
          'Remove cover. Microwave for 1-3 minutes. Remove lid & stir contents. Microwave for 1-2 minutes more or until 165°F. Plate food, let stand & enjoy!',
      },
      '003': {
        mealName: 'Tofu Pad Thai',
        description: 'A delicious stir-fried noodle dish with tofu, vegetables, and a tangy sauce.',
        tags: ['peanut free', 'good for diabetes'],
        ingredients:
          'Extra Firm Tofu, Rice Noodle (Rice, Water), Napa Cabbage, Green Bell Pepper, Water, Carrot, Crimini Mushrooms, Kikkoman LESS SODIUM GLUTEN-FREE TAMARI Soy Sauce (Water, Soybeans, Salt, Sugar, Alcohol, Vinegar, Lactic Acid), Olive Oil, Green Onion, Liquid Smoke, Rice Vinegar(Diluted with Water to 4.2% Acidity), Smooth Natural Peanut Butter, Sambal Oelek(Chili, Salt, Acetic Acid, Potassium Sorbate And Sodium Bisulfite As Preservative), Garlic, Maple Syrup, Garlic Powder, Cornstarch, Smoked Paprika, Peanuts, Cilantro, Ground Ginger, Ground Black Pepper, Salt',
        instructions:
          'Remove cover. Microwave for 1-3 minutes. Remove lid & stir contents. Microwave for 1-2 minutes more or until 165°F. Plate food, let stand & enjoy!',
      },
      '004': {
        mealName: 'Hainanese Chicken',
        description: 'A classic Singaporean dish with poached chicken and fragrant rice, served with chili sauce.',
        tags: ['protein dense', 'high in good fats'],
        ingredients:
          'Extra Firm Tofu, Rice Noodle (Rice, Water), Napa Cabbage, Green Bell Pepper, Water, Carrot, Crimini Mushrooms, Kikkoman LESS SODIUM GLUTEN-FREE TAMARI Soy Sauce (Water, Soybeans, Salt, Sugar, Alcohol, Vinegar, Lactic Acid), Olive Oil, Green Onion, Liquid Smoke, Rice Vinegar(Diluted with Water to 4.2% Acidity), Smooth Natural Peanut Butter, Sambal Oelek(Chili, Salt, Acetic Acid, Potassium Sorbate And Sodium Bisulfite As Preservative), Garlic, Maple Syrup, Garlic Powder, Cornstarch, Smoked Paprika, Peanuts, Cilantro, Ground Ginger, Ground Black Pepper, Salt',
        instructions:
          'Remove cover. Microwave for 1-3 minutes. Remove lid & stir contents. Microwave for 1-2 minutes more or until 165°F. Plate food, let stand & enjoy!',
      },
    },
    programInfo: {
      programName: 'CenCal Medically-Tailored Food Program',
      applicationStatus: {
        status: 'Active',
        actionRequired: 'Meet with Your Tangelo Dietitian',
        progressNote: '0/3 MNT Sessions Booked',
        message: 'Book time with a registered dietitian to review your Nutrition Check-Up',
      },
      mealsPerWeek: 14,
      totalWeeks: 12,
      startDate: '2024-11-25',
      endDate: '2025-12-31',
      reEnrollTime: '2025-01-01',
    },
    mealGenreGroups: {
      american: [
        { name: 'Classic Meatloaf', quantity: 0, id: 'a001' },
        { name: 'BBQ Pulled Pork', quantity: 0, id: 'a002' },
        { name: 'Grilled Chicken & Vegetables', quantity: 0, id: 'a003' },
        { name: 'Turkey & Sweet Potato Hash', quantity: 0, id: 'a004' },
        { name: 'Herb Roasted Salmon', quantity: 0, id: 'a005' },
        { name: 'Mac & Cheese with Broccoli', quantity: 0, id: 'a006' },
      ],
      asian: [
        { name: 'Lemongrass Chicken', quantity: 0, id: 'as001' },
        { name: 'Beef Pho', quantity: 0, id: 'as002' },
        { name: 'Tofu Pad Thai', quantity: 0, id: 'as003' },
        { name: 'Hainanese Chicken', quantity: 0, id: 'as004' },
        { name: 'Korean BBQ Bowl', quantity: 0, id: 'as005' },
        { name: 'Teriyaki Salmon', quantity: 0, id: 'as006' },
      ],
      latin: [
        { name: 'Chicken Fajita Bowl', quantity: 0, id: 'l001' },
        { name: 'Beef Picadillo', quantity: 0, id: 'l002' },
        { name: 'Fish Tacos', quantity: 0, id: 'l003' },
        { name: 'Ropa Vieja', quantity: 0, id: 'l004' },
        { name: 'Quinoa & Black Bean Bowl', quantity: 0, id: 'l005' },
        { name: 'Chili Verde Chicken', quantity: 0, id: 'l006' },
      ],
      mediterranean: [
        { name: 'Greek Chicken & Vegetables', quantity: 0, id: 'm001' },
        { name: 'Lamb & Couscous Bowl', quantity: 0, id: 'm002' },
        { name: 'Mediterranean Fish', quantity: 0, id: 'm003' },
        { name: 'Falafel Plate', quantity: 0, id: 'm004' },
        { name: 'Turkish Kofta', quantity: 0, id: 'm005' },
        { name: 'Shakshuka Bowl', quantity: 0, id: 'm006' },
      ],
    },
  };

  return testData;
};
